import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { NgxHybridService } from '@digipay/ngx-hybrid-service';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class MarketInterceptor implements HttpInterceptor {
  private ngxHybridService = inject(NgxHybridService);
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.ngxHybridService.isHybrid()) {
      return next.handle(request);
    }
    return from(this.ngxHybridService.getMarketName()).pipe(
      switchMap((marketName: string) => {
        const requestHeader = request.clone({
          setHeaders: {
            market: marketName,
          },
        });
        return next.handle(requestHeader);
      }),
    );
  }
}
